export const BEFORE_CALL_ENDIND_TIME = 2 * 60; // 2 минуты

export const BEFORE_OPEN_CONFIRM_MODAL_TIME = 5 * 60 * 1000; // 5 минут
